import React, { useState, useEffect } from 'react';
import EmployeeService from 'src/services/employee-service';
import CardOrderStatusPresentational from './card-order-status-presentational';
import moment from 'moment';

const CardOrderStatusFunctional = () => {
	let [pendingRequest, setPendingRequest] = useState([]);
	let [isDataLoading] = useState(false);

	const [pageNumber, setPageNumber] = useState(1);
	const [contentLoading, setContentLoading] = useState(false);

	let employeeApi = new EmployeeService();

	useEffect(() => {
		fetchPendingRequests(pageNumber);
	}, [pageNumber]);

	const handleOnScroll = () => {
		setPageNumber(pageNumber + 1);
	};
	async function fetchPendingRequests(page) {
		try {
			let params = {};
			params['pageNumber'] = page;
			params['pageSize'] = 20;
			setContentLoading(true);
			let response = await employeeApi.getCardStatus(params);
			if (response?.data) {
				let data =
					response.data.requests.map((response) => {
						response.name = `${response.numberOfRequest} Cards`;
						response.page = pageNumber;
						response.noOfCards = response.numberOfRequest;
						let orderPlacedDate = moment(response.orderPlaced);
						response.isSelected = false;
						response.order = `Order Placed: ${orderPlacedDate.format('DD MMMM YYYY')}, ${orderPlacedDate.format('h:mm a')}`;
						return response;
					}) || [];
				const sortedData = [...pendingRequest, ...data].sort((a, b) =>
					moment(b.orderPlaced).valueOf() - moment(a.orderPlaced).valueOf()
				);
				setPendingRequest(sortedData);
				setContentLoading(false);
			}
		} catch (err) {
			console.error(err);
			setContentLoading(false);
		}
	}

	return (
		<CardOrderStatusPresentational
			contentLoading={contentLoading}
			fetchPendingRequests={fetchPendingRequests}
			pendingRequest={pendingRequest}
			loading={isDataLoading}
			handleOnScroll={handleOnScroll}
		/>
	);
};

export default CardOrderStatusFunctional;
